// Side panel settings kept out of app-settings.ts, which the build replaces with a server copy.

/** Origins allowed to send draft cards to /side-panel-preview (the Blitz admin UI in each environment). */
export const SIDE_PANEL_PREVIEW_ORIGINS: string[] = [
  'https://blitzadmin.e-gmat.com',
  'https://blitzadmin.e-gmattest.com',
  'https://blitzkrieg-qa.e-gmattest.com',
  'https://blitzkrieg.e-gmattest.com',
  'http://localhost:4200',
  'http://localhost:4201'
];

/** Google Fonts used by the two design languages: Mulish (CLASSIC), Inter and Source Serif 4 (PRISM). */
export const SIDE_PANEL_FONTS_URL =
  'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&family=Mulish:wght@300;400;600;700;800&family=Source+Serif+4&display=swap';

export const SIDE_PANEL_MAX_CARDS = 2;
